const mandatePresenceStatuses = Object.freeze({
  not_present: 0,
  physical: 1,
  correspondence: 2,
  phone: 3,
  video: 4,
  pouvoir: 5,
  physical_tab: 6,
  pouvoir_by_video: 7,
  invalid_correspondence: 8,
  pouvoir_by_video_not_present_yet: 9,
});

const correspondenceTypes = Object.freeze({
  not_voted: 0,
  by_app: 1,
  by_email: 2,
  by_post: 3,
});

const cogeprintTypes = Object.freeze({
  1: `Reçu - Prêt à être imprimé`,
  2: `Imprimé et prochainement remis au centre de distribution`,
  3: "Remis au centre de distribution",
  4: `En cours de traitement par le distributeur`,
  5: `En attente de distribution`, // ???: ..
  6: `Distribution en cours`,
  7: `Le destinataire doit récupérer le plis au bureau de poste`,
  8: `Erreur en cours de traitement`,
  9: `Distribution impossible`,
  10: `Le plis a été renvoyé à l'expéditeur`,
  11: `Le plis a été distribué au destinataire`,
  12: `Le plis a été distribué à l'expéditeur`,
  13: `Le plis renvoyé à l'expéditeur a été reçu et le PDF est disponible - Uniquement si vous avez été indiqué comme destinataire des PND`,
  14: `L'accusé de réception par le destinaire a été reçu et le PDF est disponible - Uniquement si vous recevez les AR aussi`,
});

const lreRecordStatus = Object.freeze({
  ACCEPT_WAIT: "Nous attendons l'acceptation du destinataire de cette lettre",
  ACCEPT_NOTIFICATION_ERROR: "Il y a un problème pour informer le destinataire",
  REFUSED: "La lettre est refusée par le destinataire",
  EXPIRED: "La lettre est fermée car elle est expirée",
  CANCELLED: "La lettre est annulée par l'expéditeur",
  CLOSED: "La lettre est fermée car le destinataire a accepté la lettre et signé le reçu",
});

const lreRecordRecipientStatus = Object.freeze({
  ACCEPT_WAIT: "Nous attendons l'acceptation par le destinataire de la lettre",
  ACCEPT_LOCK:
    "L'acceptation est verrouillée, principalement parce que 6 faux codes ont été essayés",
  RETRIEVE_WAIT: "La lettre a été acceptée mais pas encore récupérée",
  REFUSED: "La lettre est refusée par le destinataire",
  CLOSED: "La lettre est fermée et éventuellement récupérée",
});

export {
  mandatePresenceStatuses,
  correspondenceTypes,
  cogeprintTypes,
  lreRecordStatus,
  lreRecordRecipientStatus,
};
